module.exports = __webpack_public_path__ + "img/photo_2022-10-23_14-59-31.574d3659.jpg";